import { render } from "./ReasonCode.vue?vue&type=template&id=6baa172d"
import script from "./ReasonCode.vue?vue&type=script&lang=js"
export * from "./ReasonCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__